import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  OnInit,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { BsModalRef } from "ngx-bootstrap/modal";
import { QuickbooksIntegrationService } from "src/app/dashboard/quickbooks-integration.service";

type EnrichedFile = File & {
  ext: string;
  filename: string;
  tracked_item: string;
  url: string;
};

@Component({
  selector: "app-receipt-modal",
  templateUrl: "./receipt-modal.component.html",
  styleUrls: ["./receipt-modal.component.scss"],
  standalone: true,
  imports: [CommonModule],
})
export class ReceiptModalComponent implements OnInit {
  @Input() item!: { uuid: string };
  @Output() fileUploaded = new EventEmitter<EnrichedFile>();
  @ViewChild("fileInput") fileInput!: ElementRef<HTMLInputElement>;

  selectedFile: EnrichedFile | null = null;

  constructor(
    public modalRef: BsModalRef,
    private qboService: QuickbooksIntegrationService,
  ) {}

  ngOnInit(): void {}

  onDragOver(e: DragEvent): void {
    e.preventDefault();
  }
  onDragLeave(e: DragEvent): void {
    e.preventDefault();
  }

  onDrop(e: DragEvent): void {
    e.preventDefault();
    const f = e.dataTransfer?.files?.[0];
    if (f) this.handleFile(f as EnrichedFile);
  }

  onFileSelected(e: Event): void {
    const f = (e.target as HTMLInputElement).files?.[0];
    if (f) this.handleFile(f as EnrichedFile);
  }

  private handleFile(file: EnrichedFile): void {
    if (
      !["application/pdf", "image/png", "image/jpeg", "image/jpg"].includes(
        file.type,
      )
    )
      return;
    file.ext = file.name.split(".").pop()!.toLowerCase();
    file.filename = file.name;
    file.tracked_item = this.item.uuid;
    file.url = URL.createObjectURL(file);
    this.selectedFile = file;
  }

  removeFile(): void {
    this.selectedFile = null;
    this.fileInput.nativeElement.value = "";
  }

  uploadReceipt(): void {
    if (!this.selectedFile) return;
    this.fileUploaded.emit(this.selectedFile);
    this.modalRef.hide();
  }

  closeModal(): void {
    this.modalRef.hide();
  }
}
